import type { Action } from 'redux'
import { LOGOUT } from '../../../../authentication/presentation/redux/types/log-out-types'
import type { GetUserResult } from '../../../domain/models/get-user'
import * as types from '../types/get-user-types'

export const initialStateGetUser = {
  user: null as unknown as GetUserResult,
  load: false,
  error: '',
}

export const GetUserReducer = (
  state = initialStateGetUser,
  action: Action & { payload?: any },
) => {
  const newState = { ...state }

  switch (action.type) {
    case types.GET_USER_REQUEST:
      newState.load = true
      return newState

    case types.GET_USER_ERROR:
      newState.load = false
      newState.error = action.payload
      return newState

    case types.GET_USER_SUCCESS:
      newState.load = false
      newState.user = action.payload
      return newState

    case LOGOUT:
    case types.GET_USER_RESET:
      return initialStateGetUser

    default:
      return { ...state }
  }
}
